
import { useQuery } from '@apollo/client';
import { Space } from 'antd';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import useSpinner from '../../hooks/layout/useSpinner';
import { endOfDay } from "date-fns";
import { client } from '../../apollo-clients';
import moment from 'moment';
import ItemListPagination from '../../shared/components/item-list/ItemListPagination';
import { PERFORMANCE } from './Performance.gql';
import PerformanceFilter from './PerformanceFilter';
import TableNumberFormatter from '../../shared/components/table-number-formatter/TableNumberFormatter';
import TableDateFormatter from '../../shared/components/table-date-formatter/TableDateFormatter';

const Performance = () => {
    const intl = useIntl();
    const { setLoading } = useSpinner();
    const [pageNo, setPageNo] = useState<number>(1);
    const pageSize = process.env.REACT_APP_PAGE_SIZE ? +process.env.REACT_APP_PAGE_SIZE : 10;
    const [total, setTotal] = useState<number>(0);
    const [performanceData, setPerformanceData] = useState<any>();
    const [filters, setFilters] = useState({
        userId: '',
        startDate: (new Date(moment().subtract(1, "months").toString())), endDate: endOfDay(new Date())
    });
    const { data, loading, refetch } = useQuery(PERFORMANCE, {
        variables: { pageNo, pageSize, performanceFilterInput: filters },
        client, fetchPolicy: 'cache-and-network'
    });

    useEffect(() => {
        refetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filters]);

    useEffect(() => {
        if (loading)
            setLoading(true);
        else
            setLoading(false); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loading]);

    useEffect(() => {
        if (data && data.performance) {
            setTotal(data?.performance?.count ?? 0);

            if (data.performance?.performanceList && data.performance?.performanceList?.length > 0) {
                let reportData = data.performance?.performanceList.map((val: any) => {
                    return {
                        ...val,
                        key: val.id
                    };
                })

                setPerformanceData(reportData);
            } else {
                setPerformanceData([]);
            }
        }
    }, [data])


    const columns: any = [
        {
            title: intl.formatMessage({ id: 'USERNAME' }),
            dataIndex: 'userName',
            render: (text: any) => {
                return (
                    <Space size="middle">
                        {text ?? '-'}
                    </Space>
                )
            }
        }, {
            title: intl.formatMessage({ id: 'SIGN_UP_COUNTRY' }),
            dataIndex: 'country',
            render: (text: any) => {
                return (
                    <Space size="middle">
                        {text ?? '-'}
                    </Space>
                )
            }
        }, {
            title: intl.formatMessage({ id: 'CURRENCY' }),
            dataIndex: 'currencyId',
            render: (text: any) => {
                return (
                    <Space size="middle">
                        {text ?? '-'}
                    </Space>
                )
            }
        }, {
            title: intl.formatMessage({ id: 'REGISTER_DATE' }),
            dataIndex: 'registerDate',
            render: (text: any) => {
                return (
                    <TableDateFormatter text={text} />
                )
            }
        }, {
            title: intl.formatMessage({ id: 'FIRST_DEPOSIT_DATE' }),
            dataIndex: 'firstDepositDate',
            render: (text: any) => {
                return (
                    <TableDateFormatter text={text} />
                )
            }
        }, {
            title: intl.formatMessage({ id: 'TOTAL_DEPOSIT' }),
            dataIndex: 'totalDeposit',
            render: (text: any) => {
                return (
                    <TableNumberFormatter number={text} decimalScale={2} />
                )
            }
        }, {
            title: intl.formatMessage({ id: 'TOTAL_WITHDRAW' }),
            dataIndex: 'totalWithdrawal',
            render: (text: any) => {
                return (
                    <TableNumberFormatter number={text} decimalScale={2} />
                )
            }
        }, {
            title: intl.formatMessage({ id: 'TOTAL_WITHDRAWAL_FEE' }),
            dataIndex: 'totalProcessingFee',
            render: (text: any) => {
                return (
                    <TableNumberFormatter number={text} decimalScale={2} />
                )
            }
        }, {
            title: intl.formatMessage({ id: 'TOTAL_BET_COUNT' }),
            dataIndex: 'betCount',
            render: (text: any) => {
                return (
                    <TableNumberFormatter number={text} decimalScale={0} />
                )
            }
        }, {
            title: intl.formatMessage({ id: 'TOTAL_TURNOVER' }),
            dataIndex: 'totalTurnover',
            render: (text: any) => {
                return (
                    <TableNumberFormatter number={text} decimalScale={2} />
                )
            }
        }, {
            title: intl.formatMessage({ id: 'PROFIT' }),
            dataIndex: 'profit',
            render: (text: any) => {
                return (
                    <TableNumberFormatter number={text} decimalScale={2} />
                )
            }
        }, {
            title: intl.formatMessage({ id: 'BONUS' }),
            dataIndex: 'totalBonus',
            render: (text: any) => {
                return (
                    <TableNumberFormatter number={text} decimalScale={2} />
                )
            }
        }, {
            title: intl.formatMessage({ id: 'VIP_CASH_BONUS' }),
            dataIndex: 'totalVipBonus',
            render: (text: any) => {
                return (
                    <TableNumberFormatter number={text} decimalScale={2} />
                )
            }
        },
    ]

    return (
        <div className="member-list-container">
            <PerformanceFilter setFilters={setFilters} setPageNo={setPageNo} filters={filters} />
            <ItemListPagination pageNo={pageNo} pageSize={pageSize} setPageNo={setPageNo} columns={columns} data={performanceData || []}
                total={total} />
        </div>
    )
}

export default Performance;